import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";

import ConfigureDocumentTemplateVersionPlaceholders from "./ConfigureDocumentTemplateVersionPlaceholders/ConfigureDocumentTemplateVersionPlaceholders";
import RemoveDocumentTemplateVersion from "./RemoveDocumentTemplateVersion";
import useAuthorization from "../../../custom-hooks/useAuthorization/useAuthorization";
import { DocumentTemplateVersionDTO } from "../../../models/document-templates";
import SimplePopover from "../../../reusable-components/SimplePopover/SimplePopover";
import { AUTHORIZATIONS } from "../../../utils/constants/authorization-constants";

const ButtonContainer = styled(Grid)({
  display: "flex",
  flexFlow: "column",
  padding: "10px 0",
  "& > .MuiButton-root": {
    textTransform: "none !important",
    justifyContent: "start",
  },
});

interface Props {
  item: DocumentTemplateVersionDTO;
  handleNotifyParent: () => void;
}

const DocTemplateVersionActions = ({ item, handleNotifyParent }: Props) => {
  const hasAdminAccess = useAuthorization([AUTHORIZATIONS.CompanyAccountsAccess.LegalEntityAdminAccess]);

  return (
    <SimplePopover
      buttonType="icon"
      buttonContent={<FontAwesomeIcon icon={faEllipsisV} />}
    >
      <ButtonContainer>
        <RemoveDocumentTemplateVersion
          item={item}
          handleNotifyParent={handleNotifyParent}
          disabled={!hasAdminAccess}
        />
        <ConfigureDocumentTemplateVersionPlaceholders
          placeholders={item.placeHolders}
          handleNotifyParent={handleNotifyParent}
          buttonType="text"
        />
      </ButtonContainer>
    </SimplePopover>
  );
};

export default DocTemplateVersionActions;
